import { SecurityComponentMapValue } from '@dealstack/frontend/app/pages/Valuations/views/BreakpointSummary/types';
import { HighPrecisionDecimal } from '@dealstack/shared/lib/format/currency/highPrecisionDecimal';
import {
	BreakpointSummaryPayload,
	SecurityValueOverrideField,
} from '@dealstack/shared/lib/generated';
import { find } from 'lodash';

export const getOverrideFieldValues = (
	securityInfo: SecurityComponentMapValue,
	breakpointSummaryData: BreakpointSummaryPayload | undefined
) => {
	if (securityInfo.override) {
		const { overrideValue, overrideField } = securityInfo.override;

		const tier = find(breakpointSummaryData?.tiers, { seniorityIndex: securityInfo.tier });
		const security = find(tier?.securities, { securityId: securityInfo.securityId });
		const numOfSecurities = security?.totalUnits ?? '1';

		return {
			valuePerUnit:
				overrideField === SecurityValueOverrideField.VALUE_PER_UNIT
					? new HighPrecisionDecimal(overrideValue)
					: new HighPrecisionDecimal(overrideValue).div(numOfSecurities),
			tierParticipatingValue:
				overrideField === SecurityValueOverrideField.VALUE_TOTAL_ISSUED
					? new HighPrecisionDecimal(overrideValue)
					: new HighPrecisionDecimal(overrideValue).times(numOfSecurities),
		};
	}

	return {
		valuePerUnit: securityInfo.valuePerSecurity,
		tierParticipatingValue: securityInfo.tierParticipatingValue,
	};
};
